import { useCallback } from 'react';
import { FormatNumberOptions, useIntl } from 'react-intl';

export type LocalizeNumberOptions = FormatNumberOptions;

export const useLocalizeNumber = () => {
    const intl = useIntl();

    return useCallback((value: number, options?: LocalizeNumberOptions) => intl.formatNumber(value, options), [intl]);
};
